import Vue from 'vue';
import { getSlotFromElement } from "../../../lib/renderer/utils";
import { delay, readClipboard, splitCompPath } from "../../../lib/utils";
import { highlightRect } from "../../../lib/utils/browser";
import { CTRL_KEY_LABEL } from "../../../lib/utils/consts";
import { CompNameTag } from '../UcdToolbar/CompPathBreadcrumb';
import { copyComponentToClipBoard, pasteComponentToDesigner } from './copyAndPasteComponent';
function getCompContextMenu(designer, opts = {}) {
  const actions = designer.getActiveCompActions('contextMenu').map(action => ({
    title: action.title,
    checked: action.highlighted,
    execute: () => designer.executeAction(action.execute),
    desc: action.desc,
    icon: action.icon
  }));
  const activeSlot = designer.editZoneState.currentActiveSlot;
  const ans = {
    title: '组件操作',
    items: [{
      title: '剪切',
      icon: 'fa fa-cut',
      execute: async () => {
        copyComponentToClipBoard(designer);
        await designer.deleteActiveComp();
      }
    }, {
      title: '复制',
      icon: 'fa fa-copy',
      execute: async () => {
        copyComponentToClipBoard(designer);
      }
    }, {
      title: `粘贴 (到${activeSlot ? `插槽内:${activeSlot.id}` : '后面'})`,
      icon: 'fa fa-paste',
      execute: async () => {
        try {
          const txt = await readClipboard();
          const compPath = await pasteComponentToDesigner(txt, designer);
          if (compPath) designer.compPath = compPath;
        } catch (e) {
          designer.uc.$message.error(`粘贴失败，请尝试按 ${CTRL_KEY_LABEL}-V 粘贴`);
          console.error('[UICore] Failed to Paste', e);
        }
      }
    }, {
      title: '---'
    }, ...actions]
  };
  const altSlot = !activeSlot && opts.eventTarget && getSlotFromElement(designer.renderer, designer.compPath, opts.eventTarget);
  if (altSlot) {
    ans.items.unshift({
      title: `粘贴 (到插槽内:${altSlot.id})`,
      icon: 'fa fa-paste',
      onMouseEnter() {
        var _altSlot$getSlotConta;
        highlightRect((_altSlot$getSlotConta = altSlot.getSlotContainerElement) === null || _altSlot$getSlotConta === void 0 || (_altSlot$getSlotConta = _altSlot$getSlotConta.call(altSlot)) === null || _altSlot$getSlotConta === void 0 ? void 0 : _altSlot$getSlotConta.getBoundingClientRect(), 200);
      },
      execute: async () => {
        try {
          const txt = await readClipboard();
          designer.editZoneState.currentActiveSlot = altSlot;
          const compPath = await pasteComponentToDesigner(txt, designer);
          if (compPath) designer.compPath = compPath;
        } catch (e) {
          designer.uc.$message.error('粘贴失败');
          console.error('[UICore] Failed to Paste', e);
        }
      }
    });
  }
  return ans;
}
function getCompParentTreeContextMenu(designer) {
  // eslint-disable-next-line
  const h = designer.$createElement;
  const pathParts = splitCompPath(designer.compPath).map(x => x.compPath);
  if (pathParts[0]) pathParts.unshift('');
  const showMenuAgain = () => {
    const {
      left,
      top
    } = designer.contextMenuRef;
    (async () => {
      await delay(100);
      await Vue.nextTick();
      // const elRect = designer.renderer?.getRefByPath(compPath)?.$el?.getBoundingClientRect?.();
      // if (elRect) highlightRect(elRect);
      designer.openContextMenu({
        clientX: left,
        clientY: top
      }, [getCompContextMenu(designer), getCompParentTreeContextMenu(designer)]);
    })();
  };
  const items = pathParts.reverse().map(compPath => ({
    title: h(CompNameTag, {
      "attrs": {
        "compPath": compPath,
        "showIfHaveEvents": true,
        "showIfHaveStyle": true
      },
      "style": "display: flex; max-height: 1.3em"
    }),
    execute: showMenuAgain,
    checked: compPath === designer.compPath
  }));
  if (designer.scopeStack.length > 0) {
    items.push({
      title: '---'
    }, {
      title: '回到上层',
      icon: 'fa fa-reply',
      execute: () => (designer.exitScope(), showMenuAgain())
    });
  }
  const ans = {
    title: '快速选择父级',
    items
  };
  return ans;
}
export function getCompContextMenuSections(designer, opts) {
  return [getCompContextMenu(designer, opts), getCompParentTreeContextMenu(designer)];
}
//# sourceMappingURL=contextMenu.js.map
